export function isMobile() {
    return $('html').hasClass('mobile') && screen.availWidth < 1000;
}

export function isTablet() {
    if ($('html').hasClass('windows tablet')) return false;
    return $('html').hasClass('tablet') && screen.availWidth > 760;
}

//isFuckingIpad????
export function isIpad() {
    return (/iPad|iPhone|iPod/.test(navigator.platform) ||
            (navigator.platform === 'MacIntel' && navigator.maxTouchPoints > 1)) &&
        !window.MSStream
}
